export const updateDrawHistoryForSrd = (list, newRow) => {
  return list.map((row) =>
    row.specimen_id === newRow.specimen_id ? { ...row, ...newRow } : row
  );
};

export const removeRecordForSrd = (list, newRow) => {
  console.log(newRow);
  return list.filter((row) => row.specimen_id != newRow.specimen_id);
};
